import { Alert, Button } from 'avo-ui'
import icTrash from '../../../assets/images/ic-trash.svg'
import icUpload from '../../../assets/images/ic-upload.svg'
import icAlert from '../../../assets/images/ic-warning.svg'
import { useEffect, useState } from 'react'
import clsx from 'clsx'

const UploadImage = ({
    className,
    classNameImage,
    classNameButtonDelete,
    id = 'upload-picture',
    caption,
    value,
    onChange,
}) => {
    const [fileImage, setFileImage] = useState(null)

    const showAlert = (message) => {
        Alert({
            icon: icAlert,
            title: 'Failed',
            message,
            autoClose: true,
            interval: 3000,
        })
    }

    const onUpload = async (e) => {
        const file = e.target.files[0]
        if (!file) return

        const allowedExtensions = /(\.jpg|\.jpeg|\.png)$/i
        if (!allowedExtensions.exec(file?.name)) {
            e.target.value = null
            return showAlert('Format file is invalid')
        } else if (file?.size > 10e6) {
            e.target.value = null
            return showAlert('File size is invalid, valid size are not greater than 10 mb')
        }

        const reader = new FileReader()
        reader.onload = () => {
            e.target.value = null
            const objValue = {
                file: file,
                base64: reader.result,
                name: file.name,
            }
            setFileImage(objValue?.base64)
            if (onChange) onChange(objValue)
        }
        reader.readAsDataURL(file)
    }

    const onDelete = () => {
        if (onChange) onChange(null)
        setFileImage(null)
    }

    useEffect(() => {
        setFileImage(value)
    }, [value])

    return (
        <div className={clsx('flex flex-col space-y-3 items-center', className)}>
            {fileImage && (
                <div className={'relative'}>
                    <img src={fileImage} className={clsx('w-60 h-36', classNameImage)} alt={'file-image'} />
                    <Button
                        type={'outline'}
                        icon={icTrash}
                        className={clsx('absolute top-2 right-2 !rounded-full', classNameButtonDelete)}
                        onClick={onDelete}
                    />
                </div>
            )}
            <p>{caption}</p>
            <label
                className={'avo__button bg-blue-5 border border-blue-20 hover:bg-blue-20 space-x-3 px-8'}
                htmlFor={id}
            >
                <img src={icUpload} className={'w-4'} alt={'ic-upload'} />
                <div className={'font-semibold text-blue-90'}>Upload</div>
            </label>
            <input id={id} type={'file'} className={'hidden'} accept={'image/*'} onChange={onUpload} />
        </div>
    )
}

export default UploadImage
